import React from 'react';
import PropTypes from 'prop-types';

const PageContainer = ({ className, children }) => {
    return (
        <div>
            <div className={"page-wrapper " + className}>
            <main role="main">
                {children}
            </main>
            </div>
        </div>
    );
};
PageContainer.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ])
};

export default PageContainer;
